<template>
  <div class="chart-container">
    <Pie v-if="chartReady" :data="pieChartData" :options="chartOptions" />
    <div v-else>Loading chart...</div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";
import { SENDGRID_EMAIL_STATUS } from "../../constants";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default defineComponent({
  name: "PieChartStatus",
  components: { Pie },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      SENDGRID_EMAIL_STATUS,
      chartReady: false,
      pieChartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Distribution of Email By Status",
            font: {
              size: 16,
            },
          },
        },
      },
    };
  },
  methods: {
    getColor(status) {
      return (
        SENDGRID_EMAIL_STATUS.find((p) => p.id === status)?.color ||
        "#" + Math.floor(Math.random() * 16777215).toString(16)
      );
    },
    prepareChartData() {
      const statusTotals = this.chartData.reduce((acc, item) => {
        const status = item._id.status;
        if (!acc[status]) {
          acc[status] = 0;
        }
        acc[status] += item.count;
        return acc;
      }, {});

      const labels = Object.keys(statusTotals);
      const data = Object.values(statusTotals);
      const backgroundColor = labels.map(this.getColor);

      this.pieChartData = {
        labels,
        datasets: [
          {
            backgroundColor,
            data,
          },
        ],
      };

      this.chartReady = true;
    },
  },
  watch: {
    chartData: {
      handler() {
        this.prepareChartData();
      },
      immediate: true,
      deep: true,
    },
  },
});
</script>

<style scoped>
.chart-container {
  height: 400px;
  width: 100%;
}
</style>
